'use client';

import { LatLngLiteral } from "@googlemaps/google-maps-services-js";
import {
    AdvancedMarker,
    InfoWindow,
    useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import Logo from "@/app/features/shared/layout/logo";

export default function ApproachMapContent({ coordinates }: { coordinates: LatLngLiteral }) {
    const [markerRef, marker] = useAdvancedMarkerRef();

    return (
        <>
            <AdvancedMarker ref={markerRef} position={coordinates} onClick={(e) => e.stop()} />
            <InfoWindow anchor={marker} className="title-hidden">
                <Logo variant="iconAndText" />
            </InfoWindow>
        </>
    );
}
